import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { MomentModule } from 'ngx-moment';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { ShipmentActivitiesListItemComponent } from '../shipment-activities-list-item/shipment-activities-list-item.component';

@Component({
    standalone: true,
    imports: [NgIf, RouterLink, MomentModule, FontAwesomeModule, TooltipModule, TranslateModule],
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'li[qwyk-shipment-activities-status-update]',
    templateUrl: './shipment-activities-status-update.component.html',
    styleUrls: ['./shipment-activities-status-update.component.scss'],
})
export class ShipmentActivitiesStatusUpdateComponent extends ShipmentActivitiesListItemComponent {}
